// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailInfo_wrapper_cd6f3"};